<template>
  <div class="inner-box">
    <h2 class="title">{{title}}</h2>
    <div class="title-s">방문 예약 시스템에 오신 것을 환영합니다.</div>

    <ul class="progress">
      <li>
           <span>
               <span class="order">1 </span>약관동의
           </span>
        <div class="diagonal"></div>
      </li>
      <li class="completed">
           <span>
               <span class="order">2 </span>방문신청 정보입력
           </span>
        <div class="diagonal"></div>
      </li>
      <li>
           <span>
               <span class="order">3 </span>완료
           </span>
      </li>
    </ul>

    <h1>피방문자 정보</h1>
    <table class="visit-info-table">
      <colgroup>
        <col width="35%"></col>
        <col width="*"></col>
      </colgroup>
      <tr>
        <td class="tit">방문회사</td>
        <td>
          <select v-model="form.compCd" ref="compCd">
            <option value=''>==선택==</option>
            <option value='100010'>일진전기</option>
            <option value='100002'>일진홀딩스</option>
            <option value='101301'>일진다이아</option>
            <option value='222300'>알피니언메디칼</option>
          </select>
        </td>
      </tr>
      <tr>
        <td class="tit">피방문자 연락처</td>
        <td>
          <div class="write">
            <select style="padding:10px 25px 10px 10px" v-model="employeeMobile1" :disabled="visitCheckYn === true">
              <option
                      v-for="item in mobiles"
                      :key="item"
                      :value="item"
                      v-text="item"/>
            </select>&nbsp;
            <input class="input" type="text" maxlength="4" style="width:60px;" :disabled="visitCheckYn === true" ref="employeeMobile2" v-model="employeeMobile2">&nbsp;
            <input class="input" type="text" maxlength="4" style="width:60px;" :disabled="visitCheckYn === true" ref="employeeMobile3" v-model="employeeMobile3">&nbsp;
          </div>
          <div style="height:10px"></div>
          <p class="contents-s">- 피방문자 연락처를 정확히 입력해주세요.</p>
          <p class="contents-s">- 피방문자 연락처는 숫자만 입력가능합니다.</p>
          <p class="contents-s" v-if="form.employeeDeptInfoYn != 'Y'">- 연락처 및 피방문자를 정확히 입력 후 확인버튼을 누르세요.</p>
        </td>
      </tr>

      <tr v-if="form.employeeDeptInfoYn == 'Y'">
        <td class="tit">방문부서</td>
        <td>
          <input class="input" type="text" placeholder="ex : 인사팀" v-model="form.visitDept" ref="visitDept" :disabled="visitCheckYn === true" @keydown.enter="chkVisitEmp">
          <div style="height:10px"></div>
          <p class="contents-s">- 방문부서명, 피방문자는 띄어 쓰지 마시고 붙여 쓰기 해주세요.</p>
          <p class="contents-s">- 연락처, 방문부서명, 피방문자를 정확히 입력 후 확인버튼을 누르세요.</p>
        </td>
      </tr>

      <tr>
        <td class="tit">피방문자</td>
        <td>
          <span class="control is-expanded has-icons-left">
            <input class="input" type="text" placeholder="이름" v-model="form.visitEmp" ref="visitEmp" :disabled="visitCheckYn === true" @keydown.enter="chkVisitEmp">
            <span class="icon is-small is-left">
              <i class="fas fa-user"></i>
            </span>
          </span>
          <button class="button-confirm" :disabled="visitCheckYn === true" @click="chkVisitEmp">
            확인
          </button>
          <span style="color: #1d72aa; vertical-align: middle;">&nbsp&nbsp&nbsp{{checkComment}}</span>
        </td>
      </tr>
    </table>

    <h1>신청자 정보</h1>
    <table class="visit-info-table">
      <colgroup>
        <col width="35%"></col>
        <col width="*"></col>
      </colgroup>
      <tr>
        <td class="tit">신청자</td>
        <td>
          <input class="input" type="text" ref="visitorFirstNm" v-model="form.visitorFirstNm">
        </td>
      </tr>
      <tr>
        <td class="tit">연락처</td>
        <td>
            <select style="padding:10px 25px 10px 10px" v-model="visitorFirstMobile1" ref="visitorFirstMobile1">
              <option
                      v-for="item in mobiles"
                      :key="item"
                      :value="item"
                      v-text="item"/>
            </select>&nbsp;
            <input class="input" type="text" maxlength="4" style="width:60px;" ref="visitorFirstMobile2" v-model="visitorFirstMobile2">&nbsp;
            <input class="input" type="text" maxlength="4" style="width:60px;" ref="visitorFirstMobile3" v-model="visitorFirstMobile3">
        </td>
      </tr>
      <tr>
        <td class="tit">소속회사</td>
        <td>
          <input class="input" type="text" ref="visitorComp" v-model="form.visitorComp">
        </td>
      </tr>
      <tr v-if="form.visitCompAddrInfoYn == 'Y'">
        <td class="tit">회사주소</td>
        <td>
          <input class="input" type="text" ref="visitorCompAddr" v-model="form.visitorCompAddr" style="width:100%">
        </td>
      </tr>
      <tr>
        <td class="tit">방문일</td>
        <td>
          <div class="visit-startdate">
           <span class="datepicker w-type-ymd02">
            <dhx-calendar class="input ddate sDate" v-model="form.staYmd" readonly="readonly" style="width:130px" @constructCalendarSuccessful="constructCalendarSuccessful"/>
          </span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="tit">방문목적</td>
        <td>
          <select v-model="form.purpose">
            <option
                    v-for="item in purposeCds"
                    :key="item.key"
                    :value="item.key"
                    v-text="item.value"/>
          </select>
        </td>
      </tr>
      <tr v-if="form.visitContentInfoYn == 'Y'">
        <td class="tit">내용</td>
        <td>
          <textarea class="textarea" placeholder="상세 내용을 작성해주세요." v-model="form.content" style="resize:none"></textarea>
        </td>
      </tr>
    </table>


    <h1>방문객 정보</h1>
    <div class="visit-info-list">
      <div class="info">
        ※ 방문객을 추가할경우 [방문객추가] 버튼을 사용하여 방문객을 추가하세요.<br>
        ※ 연락처는 본인 핸드폰 번호만 입력해야하며, 방문객들의 연락처는 중복 될 수 없습니다.<br>
        ※ 업무목적에 한하여 방문이 가능하며, 개인적인 목적으로는 방문이 불가합니다.<br>
        <div v-if="form.visitPLimitYn === 'Y' && form.visitPLimitCount !== ''">※ 방문객 등록은 한번에 <span style="color:blue;font-weight:bold">{{form.visitPLimitCount}}</span>명 까지만 등록 가능합니다.</div>
      </div>
      <div class="visit-info-list_header mobile_hide">
        <ul>
          <li class="list_0">
            <p class="tit">
              <span>No</span>
            </p>
          </li>
          <li class="list_1">
            <p class="tit">
              <span>방문자명</span>
            </p>
          </li>
          <li class="list_3">
            <p class="tit">
              <span>연락처</span>
            </p>
          </li>
          <li class="list_4" v-if="form.visitSecuItemYn == 'Y'">
            <p class="tit">
              <span>보안물품</span>
            </p>
          </li>
          <li class="list_5" v-if="form.visitCarInfoYn == 'Y'">
            <p class="tit">
              <span>차량정보</span>
            </p>
          </li>
          <li class="list_6">
            <p class="tit">
              <span>개인정보<br>처리방침<br>동의</span>
            </p>
          </li>
          <li class="list_7">
            <p class="tit">
              <span>개인정보<br>수집동의</span>
            </p>
          </li>
          <li class="list_8">
            <p class="tit">
              <span>삭제</span>
            </p>
          </li>
        </ul>
      </div>

      <ul v-for="(row, index) in visitors">
        <li class="list_0">
          <p class="tit m_show">
            <span>No</span>
          </p>
          <div class="write">
            {{index+1}}
          </div>
        </li>
        <li class="list_1">
          <p class="tit m_show">
            <span>방문자명</span>
          </p>
          <div class="write">
            <input class="input" type="text" :ref="'visitorNm-' + index" v-model="row.visitorNm" style="width:99%;max-width:200px">
          </div>
        </li>
        <li class="list_3">
          <p class="tit m_show">
            <span>연락처</span>
          </p>
          <div class="write">
            <select style="padding:10px 25px 10px 10px" :ref="'visitorMobile1-' + index" v-model="row.visitorMobile1">
              <option
                      v-for="item in mobiles"
                      :key="item"
                      :value="item"
                      v-text="item"/>
            </select>&nbsp;
            <input class="input" type="text" maxlength="4" style="width:60px;" :ref="'visitorMobile2-' + index" v-model="row.visitorMobile2">&nbsp;
            <input class="input" type="text" maxlength="4" style="width:60px;" :ref="'visitorMobile3-' + index" v-model="row.visitorMobile3">&nbsp;
          </div>
        </li>
        <li class="list_4" v-if="form.visitSecuItemYn == 'Y'">
          <p class="tit m_show">
            <span>보안물품</span>
          </p>
          <div class="write">
            <button class="button-itemadd" @click="secuItemAdd(row, index)">등록</button>
          </div>
        </li>
        <li class="list_5" v-if="form.visitCarInfoYn == 'Y'">
          <p class="tit m_show">
            <span>차량정보</span>
          </p>
          <div class="write">
            <button class="button-itemadd" @click="carItemAdd(row, index)">등록</button>
          </div>
        </li>
        <li class="list_6">
          <p class="tit m_show">
            <span>개인정보 처리방침 동의</span>
          </p>
          <div class="write">
            <input style="height:30px" type="checkbox" :id="'agreeChk1_'+index" v-model="row.agreeChk1"/><label :for="'agreeChk1_'+index" style="padding: 12px"><span style="padding-left:15px;color:#666;font-size:14px">동의</span></label>
          </div>
        </li>
        <li class="list_7">
          <p class="tit m_show">
            <span>개인정보 수집동의</span>
          </p>
          <div class="write">
            <input style="height:30px" type="checkbox" :id="'agreeChk2_'+index" v-model="row.agreeChk2"/><label :for="'agreeChk2_'+index" style="padding: 12px"><span style="padding-left:15px;color:#666;font-size:14px">동의</span></label>
          </div>
        </li>
        <li class="list_8">
          <p class="tit m_show">
            <span>삭제</span>
          </p>
          <div class="write">
            <button class="button-delete" @click="removeRow(index)" :ref="'delbtn-' + index">삭제</button>
          </div>
        </li>
      </ul>
    </div>

    <div style="margin:20px 10px 0 0;text-align: right">
      <button class="button-add" @click="addRow">방문객추가</button>
    </div>

    <br><br>
    <p style="border-bottom: solid 2px; font-size:25px; padding-bottom:10px; margin-bottom:25px;"></p>
    <div class="field is-horizontal">
      <div class="field-body">
        <div class="field">
          <div class="control" style="text-align: center">
            <button class="button-request" @click="save">
              신청하기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import dhxGrid from "@/components/DhxGrid.vue";
  import DhxCalendar from '@/components/DhxCalendar.vue'
  import mixin from "@/mixin/slip-common";
  import mixinSlip from '@/mixin/slip';
  import _ from "lodash";
  import Login from "@/components/Login";
  import secuItem from '@/views/el/SecuItem.vue';
  import carItem from '@/views/el/CarItem.vue';

  var eventBus = new Vue();

  const options = {};

  export default {
    name: "taxMng",
    mixins: [mixin, mixinSlip],
    components: {Login, dhxGrid, DhxCalendar},
    data() {
      return {
        title: "마곡빌딩 방명록 작성",
        compCds: [],
        purposeCds: [],
        times: [],
        funcDeptMng: [],
        funcSecuMng: [],
        funcCarMng: [],
        funcCompAddrMng: [],
        funcContentMng: [],
        funcPLimitMng: [],
        checkComment: "",
        mobiles:['010','011','016','017','018','019'],
        visitCheckYn: false,
        employeeMobile1: "010",
        employeeMobile2: "",
        employeeMobile3: "",
        visitorFirstMobile1: "010",
        visitorFirstMobile2: "",
        visitorFirstMobile3: "",
        visitorFirstBirthYear: "1800",
        visitorFirstBirthMonth: "01",
        visitorFirstBirthDay: "01",
        visitorAdd: "",
        form: {
          compCd: "",
          codeNm: "",
          businessAreaCd: "B1",
          visitDept: "",
          visitEmp: "",
          visitorFirstNm: "",
          visitorFirstMobile: "",
          visitorComp: "",
          visitorCompAddr: "",
          employeeDeptInfoYn: "N",
          visitSecuItemYn: "N",
          visitCarInfoYn: "N",
          visitCompAddrInfoYn: "N",
          visitContentInfoYn: "N",
          visitPLimitYn: "N",
          visitPLimitCount: "",
          employeeMobile: "",
          staYmd: this.$moment().format('YYYY-MM-DD'),
          staTime: "",
          staHour: "09",
          staMin: "00",
          endYmd: this.$moment().format('YYYY-MM-DD'),
          endTime: "",
          endHour: "18",
          endMin: "00",
          purpose: "",
          content: "",
        },
        visitors: [
          {
            compCd: "",
            visitorNm: "",
            visitorBirth: "",
            visitorBirthYear: "1800",
            visitorBirthMonth: "01",
            visitorBirthDay: "01",
            visitorMobile: "",
            visitorMobile1: "010",
            visitorMobile2: "",
            visitorMobile3: "",
            agreeChk1: "",
            agreeChk2: "",
            agreeChk3: "",
          }
        ],
        personItems: [],
        personCars: [],
      };
    },
    created() {
      this.getFuncDeptUsed('100010');
      this.getFuncSecuUsed('100010');
      this.getFuncCarUsed('100010');
      this.getFuncCompAddrUsed('100010');
      this.getFuncContentUsed('100010');
      this.getFuncPersonLimitUsed('100010');
      if(this.$route.params.proposal_yn !== "Y"){
        this.$swal({type: 'warning', text: '약관페이지 동의 후에 신청가능합니다.'});
        this.$router.push({path: `/ijmg/visitRequestProposal`});
      };
    },
    methods: {
      constructCalendarSuccessful(calendar) {
        calendar.setSensitiveRange(this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD'))
      },
      save() {
        if(this.visitCheckYn === false){
          this.$swal({type: 'warning', text: '방문부서 및 피방문자 정보를 확인해주세요.'});
          return false;
        }

        if(this.form.visitorFirstNm === ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '신청자를 입력해주세요.'})
                    ,10});
          this.$refs.visitorFirstNm.focus();
          this.$refs.visitorAdd.checked = false;
          return false;
        }
        const reg1 = /(\d{3,4})/;
        const reg2 = /(\d{4})/;

        if(this.visitorFirstMobile2 == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '신청자 연락처를 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs.visitorFirstMobile2.focus();
          this.$refs.visitorAdd.checked = false;
          return false;
        }

        if(!reg1.test(this.visitorFirstMobile2)){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '신청자 연락처를 정확히 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs.visitorFirstMobile2.focus();
          this.$refs.visitorAdd.checked = false;
          return false;
        }

        if(this.visitorFirstMobile3 == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '신청자 연락처를 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs.visitorFirstMobile3.focus();
          this.$refs.visitorAdd.checked = false;
          return false;
        }

        if(!reg2.test(this.visitorFirstMobile3)){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '신청자 연락처를 정확히 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs.visitorFirstMobile3.focus();
          this.$refs.visitorAdd.checked = false;
          return false;
        }

        if(this.form.visitorComp === ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '소속회사를 입력해주세요.'})
                    ,10});
          this.$refs.visitorComp.focus()
          return false;
        }

        if(this.form.visitCompAddrInfoYn === "Y"){
          if(this.form.visitorCompAddr === ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '회사주소를 입력해주세요.'})
                      ,10});
            this.$refs.visitorCompAddr.focus()
            return false;
          }
        }

        if(this.form.endYmd === "" || this.form.endYmd === undefined){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '방문기간 정보를 확인해주세요.'})
                    ,10});
          return false;
        }

        for(var i=0; i <this.visitors.length; i++) {
          const reg1 = /(\d{3,4})/;
          const reg2 = /(\d{4})/;

          if (this.visitors[i].visitorNm == "") {
            setTimeout(() => {
              this.$swal({type: 'warning', text: '방문자명을 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs["visitorNm-" + i][0].focus();
            return false;
          }

          if(this.visitors[i].visitorBirthYear == ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '생년을 선택하세요.'}).then(() => {
              })
                  ,10})
            this.$refs["visitorBirthYear-" + i][0].focus()
            return false;
          }

          if(this.visitors[i].visitorBirthMonth == ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '월을 선택하세요.'}).then(() => {
              })
                  ,10})
            this.$refs["visitorBirthMonth-" + i][0].focus()
            return false;
          }

          if(this.visitors[i].visitorBirthDay == ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '일을 선택하세요.'}).then(() => {
              })
                  ,10})
            this.$refs["visitorBirthDay-" + i][0].focus()
            return false;
          }

          if(this.visitors[i].visitorMobile2 == ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '연락처를 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs["visitorMobile2-" + i][0].focus()
            return false;
          }

          if(!reg1.test(this.visitors[i].visitorMobile2)){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '연락처를 정확히 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs["visitorMobile2-" + i][0].focus()
            return false;
          }

          if(this.visitors[i].visitorMobile3 == ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '연락처를 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs["visitorMobile3-" + i][0].focus()
            return false;
          }

          if(!reg2.test(this.visitors[i].visitorMobile3)){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '연락처를 정확히 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs["visitorMobile3-" + i][0].focus()
            return false;
          }

          //연락처 중복 체크
          this.chkOverlapMobile();

          //개인정보 처리방침, 수집동의 체크
          if(this.visitors[i].agreeChk1 != true){
            this.$swal({type: 'warning', text: '"' + this.visitors[i].visitorNm + '" 방문자의 개인정보 처리방침에 동의하시기 바랍니다.'});
            return false;
          }

          if(this.visitors[i].agreeChk2 != true){
            this.$swal({type: 'warning', text: '"' + this.visitors[i].visitorNm + '" 방문자의 개인정보수집에 동의하시기 바랍니다.'});
            return false;
          }
        }

        this.$swal({
          type: 'info',
          text: `방명록 작성을 완료합니다. 계속 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then((result) => {
          if (result.value) {
            this.form.staTime = this.form.staHour + this.form.staMin
            this.form.endTime = this.form.endHour + this.form.endMin
            const param = JSON.parse(JSON.stringify(this.form));
            const stripFields = ['staYmd', 'endYmd'];
            _.forEach(stripFields, (name) => param[name] = this.toPure(param[name]));

            this.$http.post(`/api/visit/save/book`, {
                      visitHeader : param,
                      visitDetail : this.visitors,
                      visitSecuDetail : this.personItems,
                      visitCarDetail : this.personCars
                    }
            ).then((response) => {
              this.$swal({ type: 'info', text: '완료되었습니다.'
              }).then((result) => {
                this.$router.push({path: `/ijmg/visitRequestProposal`});
              });
            }).catch((e) => {
              console.error(e);
            });
          }
        });
      },

      chkVisitEmp() {
        const reg1 = /(\d{3,4})/;
        const reg2 = /(\d{4})/;
        if(this.$store.state.loginInfo == null || this.$store.state.loginInfo == '' || this.$store.state.loginInfo == undefined){
            this.$swal({type: 'warning', text: '관리자 페이지 로그인 후 사용 바랍니다.'})
            return false;
        }

        if(this.form.businessAreaCd == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '사업장권한 계정으로 로그인 후 사용 바랍니다.'}).then(() => {
            })
                ,10})
          return false;
        }

        if(this.form.compCd == ''){
            this.$swal({type: 'warning', text: '방문회사를 선택해 주시기 바랍니다.'})
            this.$refs.compCd.focus()
            return false;
        }

        if(this.employeeMobile2 == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '피방문자 연락처를 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs.employeeMobile2.focus()
          return false;
        }

        if(!reg1.test(this.employeeMobile2)){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '피방문자 연락처를 정확히 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs.employeeMobile2.focus()
          return false;
        }

        if(this.employeeMobile3 == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '피방문자 연락처를 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs.employeeMobile3.focus()
          return false;
        }

        if(!reg2.test(this.employeeMobile3)){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '피방문자 연락처를 정확히 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs.employeeMobile3.focus()
          return false;
        }

        //관리자 페이지 방문부서 입력 YN에 따른 validation 체크
        if(this.form.employeeDeptInfoYn == 'Y'){
          if(!this.form.visitDept) {
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '방문부서를 입력해주세요.'}).then(() => {
              })
                      ,10})
            this.$refs.visitDept.focus()
            return false;
          }
        }

        if (!this.form.visitEmp) {
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '피방문자를 입력해주세요.'})
                    ,10});
          this.$refs.visitEmp.focus()
          return false;
        }

        this.$http.post(`/api/visit/checkEmp`, {
                  compCd : this.form.compCd,
                  visitDeptYn: this.form.employeeDeptInfoYn,
                  visitMobile: this.form.employeeMobile,
                  visitDept : this.form.visitDept,
                  visitEmp : this.form.visitEmp
                }
        ).then((response) => {
          this.visitCheckYn = response.data.checkYn;
          if(this.visitCheckYn === true){
            this.checkComment = "확인 완료되었습니다"
          } else {
            this.checkComment = ""
            if(this.form.employeeDeptInfoYn == "Y"){
              this.$swal({type: 'warning', text: '연락처, 방문부서, 피방문자 정보를 확인해주세요.'})
            }else{
              this.$swal({type: 'warning', text: '연락처 및 피방문자 정보를 확인해주세요.'})
            }
          }

        });
      },

      chkVisitorAdd() {
        const reg1 = /(\d{3,4})/;
        const reg2 = /(\d{4})/;

        if(this.$refs.visitorAdd.checked){ //체크했을때..

          let pchk = this.personLimitChk();
          if(pchk === false){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '방문객 등록은 ' + this.form.visitPLimitCount + '명으로 제한되어 있습니다.'}).then(() => {
              })
                      ,10})
            this.$refs.visitorAdd.checked = false;
            return false;
          }

          if(this.form.compCd == ''){
            this.$swal({type: 'warning', text: '방문회사를 선택해 주시기 바랍니다.'})
            this.$refs.compCd.focus()
            return false;
          }

          if(this.form.visitorFirstNm === ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '신청자를 입력해주세요.'})
                      ,10});
            this.$refs.visitorFirstNm.focus();
            this.$refs.visitorAdd.checked = false;
            return false;
          }
          if(this.visitorFirstMobile2 == ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '신청자 연락처를 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs.visitorFirstMobile2.focus();
            this.$refs.visitorAdd.checked = false;
            return false;
          }

          if(!reg1.test(this.visitorFirstMobile2)){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '신청자 연락처를 정확히 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs.visitorFirstMobile2.focus();
            this.$refs.visitorAdd.checked = false;
            return false;
          }

          if(this.visitorFirstMobile3 == ""){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '신청자 연락처를 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs.visitorFirstMobile3.focus();
            this.$refs.visitorAdd.checked = false;
            return false;
          }

          if(!reg2.test(this.visitorFirstMobile3)){
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '신청자 연락처를 정확히 입력하세요.'}).then(() => {
              })
                      ,10})
            this.$refs.visitorFirstMobile3.focus();
            this.$refs.visitorAdd.checked = false;
            return false;
          }

          this.$refs.visitorFirstNm.disabled = true;
          this.$refs.visitorFirstMobile1.disabled = true;
          this.$refs.visitorFirstMobile2.disabled = true;
          this.$refs.visitorFirstMobile3.disabled = true;

          //방문객 정보에 추가
          this.visitors.unshift({
            compCd:this.form.compCd,
            visitorNm: this.form.visitorFirstNm,
            visitorBirthYear:"1800",
            visitorBirthMonth:"01",
            visitorBirthDay:"01",
            visitorMobile1: this.visitorFirstMobile1,
            visitorMobile2: this.visitorFirstMobile2,
            visitorMobile3: this.visitorFirstMobile3,
            agreeChk1:"",
            agreeChk2:"",
            agreeChk3:""
          });

          this.$refs["visitorNm-" + 0][0].disabled = true;
          this.$refs["visitorMobile1-" + 0][0].disabled = true;
          this.$refs["visitorMobile2-" + 0][0].disabled = true
          this.$refs["visitorMobile3-" + 0][0].disabled = true;
          this.$refs["delbtn-" + 0][0].disabled = true;
          this.$refs["delbtn-" + 0][0].style.backgroundColor = "#aaaaaa";

          //방문객 사용자의 보안물품 Seq 하나씩 추가
          let index = 0 + 1;
          let personNum = this.personItems.length;
          for(let y=this.personItems.length-1; y >= 0; y--){
            if(this.personItems[y].visitorSeq >= index){
              this.personItems[y].visitorSeq = this.personItems[y].visitorSeq + 1
            }
          }

          //해당 사용자의 차량정보 Seq 하나씩 추가
          personNum = this.personCars.length;
          for(let y=this.personCars.length-1; y >= 0; y--){
            if(this.personCars[y].visitorSeq >= index){
              this.personCars[y].visitorSeq = this.personCars[y].visitorSeq + 1
            }
          }

        } else {  //체크 해제했을때..
          this.$swal({
            type: 'info',
            text: '방문객 정보 내 신청자 정보를 삭제 하시겠습니까?',
            showCancelButton: true,
            confirmButtonText: '예',
            cancelButtonText: '아니오',
          }).then((result) => {
            if (result.value) {
              if(this.visitors.length == 1){
                this.$swal({type: 'warning', text: '첫번째 항목은 삭제 할 수 없습니다.'});
                this.$refs.visitorAdd.checked = true;
                return false;
              }else{
                this.$refs.visitorFirstNm.disabled = false;
                this.$refs.visitorFirstMobile1.disabled = false;
                this.$refs.visitorFirstMobile2.disabled = false;
                this.$refs.visitorFirstMobile3.disabled = false;
                this.removeRow(0);
                this.$refs["visitorNm-" + 0][0].disabled = false;
                this.$refs["visitorMobile1-" + 0][0].disabled = false;
                this.$refs["visitorMobile2-" + 0][0].disabled = false;
                this.$refs["visitorMobile3-" + 0][0].disabled = false;
                this.$refs["delbtn-" + 0][0].disabled = false;
                this.$refs["delbtn-" + 0][0].style.backgroundColor = "#ad1b1b";
              }
            }else{
              this.$refs.visitorAdd.checked = true;
            }
          })
        }
      },

      //연락처 중복 체크
      chkOverlapMobile(){
        const reg1 = /(\d{3,4})/;
        const reg2 = /(\d{4})/;
        var sflag = false;

        for(var i=0; i <this.visitors.length; i++) {
          for(var j=0; j < this.visitors.length; j++) {
            if(reg1.test(this.visitors[j].visitorMobile2) && reg2.test(this.visitors[j].visitorMobile3)){
              if( j !== i ) {
                if(this.visitors[j].visitorMobile === this.visitors[i].visitorMobile) {
                  this.$refs["visitorMobile1-" + i][0].style.backgroundColor = "#a6a6a6";
                  this.$refs["visitorMobile2-" + i][0].style.backgroundColor = "#a6a6a6";
                  this.$refs["visitorMobile3-" + i][0].style.backgroundColor = "#a6a6a6";
                  this.$refs["visitorMobile1-" + j][0].style.backgroundColor = "#a6a6a6";
                  this.$refs["visitorMobile2-" + j][0].style.backgroundColor = "#a6a6a6";
                  this.$refs["visitorMobile3-" + j][0].style.backgroundColor = "#a6a6a6";
                  sflag = true;
                }else{
                  //방문자명이 disabled 라면, 신청자를 방문객으로 추가한 방문객으로 판단하여 배경색 바꾸지 않음.
                  if(this.$refs["visitorNm-" + j][0].disabled === true){
                    this.$refs["visitorMobile1-" + j][0].style.backgroundColor = "#f0f3f7";
                    this.$refs["visitorMobile2-" + j][0].style.backgroundColor = "#f0f3f7";
                    this.$refs["visitorMobile3-" + j][0].style.backgroundColor = "#f0f3f7";
                  }else{
                    this.$refs["visitorMobile1-" + j][0].style.backgroundColor = "#ffffff";
                    this.$refs["visitorMobile2-" + j][0].style.backgroundColor = "#ffffff";
                    this.$refs["visitorMobile3-" + j][0].style.backgroundColor = "#ffffff";
                  }
                }
              }
            }else{
              //방문자명이 disabled 라면, 신청자를 방문객으로 추가한 방문객으로 판단하여 배경색 바꾸지 않음.
              if(this.$refs["visitorNm-" + j][0].disabled === true){
                this.$refs["visitorMobile1-" + j][0].style.backgroundColor = "#f0f3f7";
                this.$refs["visitorMobile2-" + j][0].style.backgroundColor = "#f0f3f7";
                this.$refs["visitorMobile3-" + j][0].style.backgroundColor = "#f0f3f7";
              }else{
                this.$refs["visitorMobile1-" + j][0].style.backgroundColor = "#ffffff";
                this.$refs["visitorMobile2-" + j][0].style.backgroundColor = "#ffffff";
                this.$refs["visitorMobile3-" + j][0].style.backgroundColor = "#ffffff";
              }
            }
          }

          if(sflag === false) {
            if(this.$refs["visitorNm-" + i][0].disabled === false){
              this.$refs["visitorMobile1-" + i][0].style.backgroundColor = "#ffffff";
              this.$refs["visitorMobile2-" + i][0].style.backgroundColor = "#ffffff";
              this.$refs["visitorMobile3-" + i][0].style.backgroundColor = "#ffffff";
            }
          }

          if(sflag === true) {
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '방문객 정보에 중복 연락처가 존재합니다.'})
                      ,10});
            return false;
          }
        }
      },
      getPurposeCdCombo(compCd) {
        this.$http.get(`/api/code/combo`, { params: { compCd: compCd, groupCd: "PURPOSE_CD" } })
                .then(response => {
                  this.purposeCds = response.data;
                  this.form.purpose = this.purposeCds[0].key;
                });
      },
      getFuncDeptUsed(compCd) {
        this.$http.get(`/api/func/getFuncUse`, { params: { compCd: compCd, funcCd: "VISIT_DEPT_YN" } })
                .then(response => {
                  this.funcDeptMng = response.data;
                  this.form.employeeDeptInfoYn = this.funcDeptMng[0].adminFuncCd;
                });
      },
      getFuncSecuUsed(compCd) {
        this.$http.get(`/api/func/getFuncUse`, { params: { compCd: compCd, funcCd: "SECU_ITEM_YN" } })
                .then(response => {
                  this.funcSecuMng = response.data;
                  this.form.visitSecuItemYn = this.funcSecuMng[0].adminFuncCd;
                });
      },
      getFuncCarUsed(compCd) {
        this.$http.get(`/api/func/getFuncUse`, { params: { compCd: compCd, funcCd: "CAR_INFO_YN" } })
                .then(response => {
                  this.funcCarMng = response.data;
                  this.form.visitCarInfoYn = this.funcCarMng[0].adminFuncCd;
                });
      },
      getFuncCompAddrUsed(compCd) {
        this.$http.get(`/api/func/getFuncUse`, { params: { compCd: compCd, funcCd: "COMP_ADDRESS_YN" } })
                .then(response => {
                  this.funcCompAddrMng = response.data;
                  this.form.visitCompAddrInfoYn = this.funcCompAddrMng[0].adminFuncCd;
                });
      },
      getFuncContentUsed(compCd) {
        this.$http.get(`/api/func/getFuncUse`, { params: { compCd: compCd, funcCd: "CONTENT_YN" } })
                .then(response => {
                  this.funcContentMng = response.data;
                  this.form.visitContentInfoYn = this.funcContentMng[0].adminFuncCd;
                });
      },
      getFuncPersonLimitUsed(compCd) {
        this.$http.get(`/api/func/getFuncUse`, { params: { compCd: compCd, funcCd: "VISIT_PERSON_LIMIT" } })
                .then(response => {
                  this.funcPLimitMng = response.data;
                  this.form.visitPLimitYn = this.funcPLimitMng[0].adminFuncCd;
                  this.form.visitPLimitCount = this.funcPLimitMng[0].configValue;
                });
      },
      getTimes() {
        for(let i = 6; i < 24; i++) {
          this.times.push({
            key: this.zeroFill(i, 2),
            value: this.zeroFill(i, 2)
          });

        }
      },
      zeroFill(number, width) {
        width -= number.toString().length;
        if ( width > 0 )
        {
          return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
        }
        return number + ""; // always return a string
      },

      addRow(){
        if(this.form.compCd == ''){
          this.$swal({type: 'warning', text: '방문회사를 선택해 주시기 바랍니다.'})
          this.$refs.compCd.focus()
          return false;
        }

        let pchk = this.personLimitChk();
        if(pchk === false){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '방문객 등록은 ' + this.form.visitPLimitCount + '명으로 제한되어 있습니다.'}).then(() => {
            })
                    ,10})
          return false;
        }
        this.visitors.push({compCd:this.form.compCd,visitorNm:"",visitorBirthYear:"1800",visitorBirthMonth:"01",visitorBirthDay:"01",visitorMobile1:"010",visitorMobile2:"",visitorMobile3:"",agreeChk1:"",agreeChk2:"",agreeChk3:""});
      },

      personLimitChk(){
        if(this.form.visitPLimitYn === 'Y') {  //기능관리 인원수 제한 사용값
          if(this.form.visitPLimitCount !== ""){
            if(this.visitors.length >= this.form.visitPLimitCount) {
              setTimeout(()=> {
                this.$swal({type: 'warning', text: this.form.visitPLimitCount + '명 이상 등록할 수 없습니다.'}).then(() => {
                })
                        ,10})
              return false;
            }else{
              return true;
            }
          }
        }
      },

      removeRow(index){
        if(this.visitors.length == 1){
          this.$swal({type: 'warning', text: '해당 항목은 삭제 할 수 없습니다.'});
          return false;
        } else {
          this.visitors.splice(index, 1);

          //해당 사용자의 보안물품 항목 삭제 로직
          index = index + 1;
          let personNum = this.personItems.length;
          if (personNum > 0){
            for(let i=personNum-1; i >= 0; i--){
              if(this.personItems[i].visitorSeq == index) {
                this.personItems.splice(i,1);
              }
            }
          }
          for(let y=this.personItems.length-1; y >= 0; y--){
            if(this.personItems[y].visitorSeq > index){
              this.personItems[y].visitorSeq = this.personItems[y].visitorSeq - 1
            }
          }

          //해당 사용자의 차량정보 삭제 로직
          personNum = this.personCars.length;
          if (personNum > 0){
            for(let i=personNum-1; i >= 0; i--){
              if(this.personCars[i].visitorSeq == index) {
                this.personCars.splice(i,1);
              }
            }
          }
          for(let y=this.personCars.length-1; y >= 0; y--){
            if(this.personCars[y].visitorSeq > index){
              this.personCars[y].visitorSeq = this.personCars[y].visitorSeq - 1
            }
          }

        }
      },

      secuItemAdd(row, index){
        let vm = this;
        const reg1 = /(\d{3,4})/;
        const reg2 = /(\d{4})/;

        if(row.visitorNm == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '방문자명을 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorNm-" + index][0].focus()
          return false;
        }

        if(row.visitorMobile2 == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '연락처를 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorMobile2-" + index][0].focus()
          return false;
        }

        if(!reg1.test(row.visitorMobile2)){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '연락처를 정확히 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorMobile2-" + index][0].focus()
          return false;
        }

        if(row.visitorMobile3 == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '연락처를 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorMobile3-" + index][0].focus()
          return false;
        }

        if(!reg2.test(row.visitorMobile3)){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '연락처를 정확히 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorMobile3-" + index][0].focus()
          return false;
        }

        this.$modal.open({
          component: secuItem,
          props: {
            childVisitNm : row.visitorNm,
            visitorSeq : index + 1,
            childPersonItems : vm.personItems,
            compCd : this.form.compCd
          },
          parent: this,
          width: 850,
          events: {
            close(data) {
              let personNum = vm.personItems.length;
              if (personNum > 0){
                for(let y=personNum-1; y >= 0; y--){
                  if(vm.personItems[y].visitorSeq == data.visitorSeq) {
                    vm.personItems.splice(y, 1);
                  }
                }
              }

              for(let i=0; i <= data.items.length-1; i++) {
                vm.personItems.push({
                  useContents : data.useContents,
                  visitorSeq : data.visitorSeq,
                  visitorSecuSeq : i + 1,
                  visitorAssetCd : data.items[i].visitorAssetCd,
                  takeOfOut : data.items[i].takeOfOut,
                  visitorCategoryCd : data.items[i].visitorCategoryCd,
                  modelNm : data.items[i].modelNm,
                  serialNm : data.items[i].serialNm
                });
              }
            }
          }
        })
      },

      carItemAdd(row, index){
        let vm = this;
        const reg1 = /(\d{3,4})/;
        const reg2 = /(\d{4})/;

        if(row.visitorNm == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '방문자명을 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorNm-" + index][0].focus()
          return false;
        }

        if(row.visitorMobile2 == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '연락처를 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorMobile2-" + index][0].focus()
          return false;
        }

        if(!reg1.test(row.visitorMobile2)){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '연락처를 정확히 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorMobile2-" + index][0].focus()
          return false;
        }

        if(row.visitorMobile3 == ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '연락처를 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorMobile3-" + index][0].focus()
          return false;
        }

        if(!reg2.test(row.visitorMobile3)){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '연락처를 정확히 입력하세요.'}).then(() => {
            })
                    ,10})
          this.$refs["visitorMobile3-" + index][0].focus()
          return false;
        }

        this.$modal.open({
          component: carItem,
          props: {
            childVisitNm : row.visitorNm,
            visitorSeq : index + 1,
            childPersonCars : vm.personCars,
            compCd : this.form.compCd
          },
          parent: this,
          width: 850,
          events: {
            close(data) {
              let personNum = vm.personCars.length;
              if (personNum > 0){
                for(let y=personNum-1; y >= 0; y--){
                  if(vm.personCars[y].visitorSeq == data.visitorSeq) {
                    vm.personCars.splice(y, 1);
                  }
                }
              }

              vm.personCars.push({
                visitorSeq : data.visitorSeq,
                purpose : data.purpose,
                carCategory : data.carCategory,
                carNm : data.carNm,
                carNumber : data.carNumber,
              });

            }
          }
        })
      },

    },
    watch: {
      'form.visitorFirstNm': {
        immediate: true,
        deep: true,
        handler(value) {
          this.visitors[0].visitorNm = value
        }
      },
      'visitorFirstBirthYear' : {
        immediate: true,
        deep: true,
        handler(value) {
          this.visitors[0].visitorBirthYear = value
        },
      },
      'visitorFirstBirthMonth' : {
        immediate: true,
        deep: true,
        handler(value) {
          this.visitors[0].visitorBirthMonth = value
        },
      },
      'visitorFirstBirthDay' : {
        immediate: true,
        deep: true,
        handler(value) {
          this.visitors[0].visitorBirthDay = value
        },
      },
      'form.visitEmp': {
        immediate: true,
        deep: true,
        handler() {
          this.visitCheckYn = false
          this.checkComment = ""
        }
      },

      'form.visitDept': {
        immediate: true,
        deep: true,
        handler() {
          this.visitCheckYn = false
          this.checkComment = ""
        },
      },

      'form.staYmd': {
        immediate: true,
        deep: true,
        handler() {
          let startDate = this.form.staYmd.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          let endDate = this.form.endYmd.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          let startDateCompare = new Date(startDate);
          let endDateCompare = new Date(endDate);

          if(startDateCompare.getTime() > endDateCompare.getTime()) {
            setTimeout(()=> {
              this.form.endYmd = "";
              this.$swal({type: 'warning', text: '방문기간 정보를 확인해주세요.'})
                      ,10});
            return false;
          }

        },
      },

      'form.endYmd': {
        immediate: true,
        deep: true,
        handler() {
          let startDate = this.form.staYmd.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          let endDate = this.form.endYmd.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          let startDateCompare = new Date(startDate);
          let endDateCompare = new Date(endDate);

          if(startDateCompare.getTime() > endDateCompare.getTime()) {
            setTimeout(()=> {
              this.form.endYmd = "";
              this.$swal({type: 'warning', text: '방문기간 정보를 확인해주세요.'})
                      ,10});
            return false;
          }

        },
      },

      'employeeMobile1' : {
        immediate: true,
        deep: true,
        handler() {
          this.form.employeeMobile = this.employeeMobile1 + this.employeeMobile2 + this.employeeMobile3;
        },
      },

      'employeeMobile2' : {
        immediate: true,
        deep: true,
        handler() {
          this.form.employeeMobile = this.employeeMobile1 + this.employeeMobile2 + this.employeeMobile3;
          this.employeeMobile2 = this.employeeMobile2.replace(/-/g, '').replace(/[^0-9]/g,'');
        },
      },

      'employeeMobile3' : {
        immediate: true,
        deep: true,
        handler() {
          this.form.employeeMobile = this.employeeMobile1 + this.employeeMobile2 + this.employeeMobile3;
          this.employeeMobile3 = this.employeeMobile3.replace(/-/g, '').replace(/[^0-9]/g,'');
        },
      },
      'visitorFirstMobile1' : {
        immediate: true,
        deep: true,
        handler(value) {
          this.visitors[0].visitorMobile1 = value
          this.form.visitorFirstMobile = this.visitorFirstMobile1 + this.visitorFirstMobile2 + this.visitorFirstMobile3;
        },
      },

      'visitorFirstMobile2' : {
        immediate: true,
        deep: true,
        handler(value) {
          this.visitors[0].visitorMobile2 = value
          this.form.visitorFirstMobile = this.visitorFirstMobile1 + this.visitorFirstMobile2 + this.visitorFirstMobile3;
          this.visitorFirstMobile2 = this.visitorFirstMobile2.replace(/-/g, '').replace(/[^0-9]/g,'');
        },
      },

      'visitorFirstMobile3' : {
        immediate: true,
        deep: true,
        handler(value) {
          this.visitors[0].visitorMobile3 = value
          this.form.visitorFirstMobile = this.visitorFirstMobile1 + this.visitorFirstMobile2 + this.visitorFirstMobile3;
          this.visitorFirstMobile3 = this.visitorFirstMobile3.replace(/-/g, '').replace(/[^0-9]/g,'');
        },
      },
      'visitors' : {
        immediate: true,
        deep: true,
        handler(){
          for(var i=0; i <this.visitors.length; i++) {
            this.visitors[i].visitorBirth = this.visitors[i].visitorBirthYear + this.visitors[i].visitorBirthMonth + this.visitors[i].visitorBirthDay;
            this.visitors[i].visitorMobile = this.visitors[i].visitorMobile1 + this.visitors[i].visitorMobile2 + this.visitors[i].visitorMobile3;
            this.visitors[i].visitorMobile2 = this.visitors[i].visitorMobile2.replace(/-/g, '').replace(/[^0-9]/g,'');
            this.visitors[i].visitorMobile3 = this.visitors[i].visitorMobile3.replace(/-/g, '').replace(/[^0-9]/g,'');
          }
          setTimeout(()=> {
            //연락처 중복 체크
            this.chkOverlapMobile()
          ,10})

        },
      },
      'form.compCd' : {
        immediate: true,
        deep:true,
        handler(value) {
          this.visitors.forEach((item)=>{
            item.compCd = value
          })
          this.visitCheckYn= false
          this.checkComment = ''
        }
      }

    },
    computed: {
      hours () {
        const hour = 6;
        return Array.from({length: 19}, (value, index) => hour + index);
      },

      years () {
        const year = new Date().getFullYear() - 18; //만18세 이상
        return Array.from({length: 59}, (value, index) => year - index);  //70세까지
      }
    },
    mounted() {
      this.$refs["visitorNm-" + 0][0].disabled = true;
      this.$refs["visitorMobile1-" + 0][0].disabled = true;
      this.$refs["visitorMobile2-" + 0][0].disabled = true;
      this.$refs["visitorMobile3-" + 0][0].disabled = true;
      this.$refs["delbtn-" + 0][0].disabled = true;
      this.$refs["delbtn-" + 0][0].backgroundColor = true;
      this.getPurposeCdCombo('100010');
      this.getTimes();
    }
  };
</script>

<style lang="scss" scoped>

  .inner-box{
    height: 100%;
    width:95%;
    left: 0;
    right: 0;
    margin: 0 auto 13%;
  }

  .title{
    font-size:40px;
    text-align:center;
    margin-top:50px;
  }

  .title-s{
    font-size:15px;
    color:#666;
    text-align:center;
    padding:0 0 30px 0;
  }

  .inner-box h1{
    font-size:20px;
    padding:50px 0 10px 0;
    font-weight: bold;
  }

  .progress {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    height: 60px;
    margin: 0 0 1em;
    padding: 0;
  }

  .progress > li {
    width: 100% !important;
    height: 100% !important;
    border-radius: 0 !important;
    color: #fff !important;
    list-style: none;
    font-size: 13px;
    background-color: #bbb;
    position: relative;
    text-align: center;
  }

  .progress > li:last-child {
    border-right: 0;
  }

  .progress > li.completed {
    background-color: #0071bc;
    text-align: center;
    padding-left: 20px;
  }

  .progress > li:not(.completed) {
    padding-left: 0px;
  }

  .progress > li span {
    position: relative;
    top: 17px;
  }

  .progress > li span .order {
    border: 1px solid #ababab;
    border-radius: 27px;
    width: 23px;
    height: 23px;
    background-color: #fff;
    color: #9a9898;
    margin: 0 5px 0 10px;
    font-weight: bold;
    text-align: center;
    position: relative;
    top: 1px;
    font-size: 13px;
    display:none;
  }

  .diagonal {
    width: 0;
    height: 0;
    border-top: 30px solid transparent;
    border-bottom: 30px solid transparent;
    border-left: 20px solid #bbb;
    top: 0; right: 0;
    position: absolute;
    transform: translateX(100%);
    z-index: 1;
  }
  .completed .diagonal {
    border-left-color: #0071bc;
  }


  .inner-box button{
    padding:10px;
    border:1px solid #d5d5d5;
    text-align:center;
    font-weight: bold;
  }

  .inner-box .button-confirm{
    background-color: #3f3f3f;
    color:#fff;
    width:70px;
  }

  .inner-box .button-delete{
    background-color: #ad1b1b;
    color:#fff;
    width:50px;
  }

  .inner-box .button-add{
    background-color: #3f3f3f;
    color:#fff;
    width:100px;
  }

  .inner-box .button-itemadd{
    background-color: #023e7c;
    color:#fff;
    width:99%;
  }

  .inner-box .button-request{
    background-color: #023e7c;
    color:#fff;
    width:150px;
  }

  table.visit-info-table{
    border-top: 1px solid #aaaaaa;
    width: 100%;
  }

  table.visit-info-table td {
    border-bottom: 1px solid #ddd;
    color: #999;
    padding: 15px 0 15px 10px;
    font-size: 14px;
    vertical-align: middle;
  }

  table.visit-info-table td input{
    width: 35%;
    height: 40px;
    display:inline-block;
  }

  table.visit-info-table td p input{
    width: 100%;
  }

  table.visit-info-table td select{
    padding:10px 40px 10px 15px;
  }

  table.visit-info-table td.tit{
    background: #f9f9f9;
    padding-left: 30px;
    color: #666;
    line-height: normal;
  }

  table.visit-info-table td.tit-c{
    background: #f9f9f9;
    color: #666;
    line-height: normal;
    text-align: center;
  }

  table.visit-info-table td.list-c{
    text-align: center;
  }

  table.visit-info-table td button{
    margin-left:10px;
  }

  .contents-s{
    font-size: 11px;
  }

  .mobile_hide {
    display: none;
  }

  .visit-info-list .info {
    border-top: 1px solid #333;
    padding:10px 0 10px 20px;
    font-size:13px;
  }

  .visit-info-list ul{
    border-top: 1px solid #333;
    border-right: 0px;
    border-left: 0px;
  }

  .visit-info-list ul li {
    float: none;
    display: table;
    table-layout: fixed;
    width: 100%;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  .visit-info-list ul li input{
    height:40px;
    display:inline-block;
  }

  .visit-info-list ul li .tit.m_show {
    display: table-cell;
  }

  .visit-info-list ul li .tit {
    padding-left: 10px;
    color: #666;
    background: #f9f9f9;
    display: table-cell;
    width: 35%;
    vertical-align: middle;
    font-size: 14px;
  }

  .visit-info-list ul li .write {
    text-align: left;
    padding: 10px 0 10px 10px;
    vertical-align: middle;
  }

  @media (min-width: 450px) {
    .progress > li {
      font-size: 15px;
    }

    .progress > li span .order {
      width: 25px;
      height: 25px;
      line-height: 23px;
    }
  }

  @media (min-width: 700px) {
    .progress > li.completed {
      padding-left: 0px;
    }

    .progress > li {
      font-size: 18px;
    }
    .progress > li span .order {
      top: -1px;
      width: 28px;
      height: 28px;
      line-height: 25px;
      display: inline-block;
    }
  }

  @media (min-width: 1000px) {
    .inner-box{
      width:1000px;
    }

    .mobile_hide {
      display: inline;
      margin:0px;
      padding:0px;
    }

    .visit-startdate {
      float:left;
    }

    .visit-info-list ul li .tit.m_show {
      display: none;
    }

    .visit-info-list ul {
      border-top: 0px;
      table-layout: fixed;
      display: table;
      width: 100%;
    }

    .visit-info-list .visit-info-list_header ul {
      border-top: 1px solid #333;
      display: table;
      table-layout: fixed;
      width: 100%;
    }

    .visit-info-list .visit-info-list_header ul li {
      display: table-cell;
      float: none;
      vertical-align: middle;
      padding: 15px 0;
    }

    .visit-info-list ul li {
      overflow: hidden;
      border-bottom: 1px solid #ddd;
      display: table-cell;
      width: 8%;
      text-align: center;
      vertical-align: middle;
    }

    .visit-info-list ul li .tit {
      color: #333;
      line-height: normal;
      background: #ffffff;
      font-size: 13px;
      width: 20%;
    }

    .visit-info-list ul li .write {
      padding: 10px 0 10px 5px;
      width: 100%;
      text-align: center;
    }

    .visit-info-list ul li.list_0 {
      width: 8%;
    }

    .visit-info-list ul li.list_1 {
      width: 10%;
    }

    .visit-info-list ul li.list_2 {
      width: 21%;
    }

    .visit-info-list ul li.list_3 {
      width: 21%;
    }

    .visit-info-list ul li.list_4 {
      width: 8%;
    }

    .visit-info-list ul li.list_5 {
      width: 8%;
    }

    .visit-info-list ul li.list_6 {
      width: 8%;
    }

    .visit-info-list ul li.list_7 {
      width: 8%;
    }

    .visit-info-list ul li.list_8 {
      width: 8%;
    }

    input[type=checkbox]+label span{
      display:none;
    }

    .inner-box .button-itemadd{
      background-color: #023e7c;
      color:#fff;
      width:65px;
    }

  }
</style>